export default class AuthRememberPassword {
    public username?: string;
    constructor(
        username: string | undefined
    ) {
        this.username = username;
    }
    public formIsComplete(): any {
        return !!(this.username)
    }

    public emailIsValid(): any {
        return this.username ?
            this.username.indexOf("@") !== -1 ?
                this.username.split("@")[0] &&
                    this.username.split("@")[0].length &&
                    this.username.split("@")[1] &&
                    this.username.split("@")[1].length
                    ? true : false
                : false
            : false
    }
    public typeError(): any {
        if (!this.formIsComplete()) {
            return 'formIncomplete';
        } else if (!this.emailIsValid()) {
            return 'emailInvalid';
        } else {
            return undefined;
        }
    }
    public isValid(): any {
        return !!(this.username && this.emailIsValid());
    }
}